import React, { Fragment } from 'react'
import propTypes from 'prop-types'
import sccssIcon from '../../../images/new-error-icon.svg'
import Button from '../Button'

const errorModal = ({
  size,
  center,
  msg,
  buttonText,
  t,
  handleClose,
  className,
  details,
}) => (
  <Fragment>
    <div className={`custom-modal ${size} ${className} custom-error-modal center`}>
      <img src={sccssIcon} />
      <h4 className='text-danger'>{t('offlineActivity.opsMessage')}</h4>
      <span className={`${center && ' text-center'}`}>{msg}</span>
      {details && (
        <span
          className={`no-margin-top error-modal-details${
            center && ' text-center'
          }`}
        >
          <span className='no-margin'>{`${t('details')}: `}</span>
          <i>{details}</i>
        </span>
      )}
      <Button
        className='btn btn-primary w-100'
        text={buttonText || t('close')}
        onClick={() => handleClose()}
      />
    </div>
    <div className='bg' onClick={() => handleClose()} />
  </Fragment>
)

errorModal.propTypes = {
  size: propTypes.string,
  handleClose: propTypes.func,
  msg: propTypes.string,
  t: propTypes.func,
  center: propTypes.bool,
  buttonText: propTypes.string,
  details: propTypes.string,
  className: propTypes.string,
}

export default errorModal
